import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import { ISource } from './typings'
import { getSources } from './api'

const sourceAdapter = createEntityAdapter<ISource>({
  sortComparer: (a, b) => a.name.localeCompare(b.name),
})

export const initialState = sourceAdapter.getInitialState()

const sources = createSlice({
  name: 'sources',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSources.pending, (state) => {
      sourceAdapter.removeAll(state)
    })
    builder.addCase(getSources.fulfilled, (state, { payload }) =>
      sourceAdapter.setAll(state, payload),
    )
  },
})

export default sources.reducer

export const { selectAll: selectAllSources, selectById: selectSourceById } =
  sourceAdapter.getSelectors<StoreData>((state) => state.sources)

export const activeSources = (
  sources: ISource[],
  sourceRequired: boolean,
): ISource[] => {
  //If Source is an optional setting, then insert the "No source selected" as the first option item
  if (!sourceRequired) {
    const temp: ISource = {
      id: '0',
      name: '< No source selected >',
      description: 'No source selected',
      active: true,
    }
    sources.unshift(temp)
  }

  return sources.filter((p) => p.active && p.name != '')
}
